import { ACCEPT_WELCOME_MESSAGE, WelcomeMessageActions } from "./types";

const initialState = false;

export default (state: boolean = initialState, action: WelcomeMessageActions): boolean => {
    switch (action.type) {
        case ACCEPT_WELCOME_MESSAGE:
            return true;
        default:
            return state;
    }
};
